import { Component, Input, OnInit } from '@angular/core';
import { NotificationAlertLevel } from '../notification-alert-level.enum';

@Component({
    selector: 'banner-notification',
    templateUrl: './banner-notification.component.html',
    styleUrls: ['./banner-notification.component.scss'],
    standalone: false
})
export class BannerNotificationComponent implements OnInit {

  @Input() alertLevel: NotificationAlertLevel = NotificationAlertLevel.Error
  @Input() showIcon: boolean = true

  constructor() { }

  ngOnInit(): void {
  }

}
